<template>
    <div ref="activeRoutePoint" class="active-route-point">
        <div class="route-point-header" @click.stop="openPointModal">
            <div class="route-status text-h5" :style="{ background: pointData.status.color }">
                {{ pointIndex + 1 }}
            </div>
            <div class="route-address text-h5 text-bold">
                {{ pointData.address }}
            </div>
            <div class="route-icons">
                <div
                    v-if="pointData?.comment?.text?.length"
                    class="quick-note-btn"
                    @click.stop="openCommentModal"
                >
                    <img src="@/assets/images/quick-note-icon.svg" alt="" />
                </div>
                <div v-if="passengerCount > 0" class="passengers-qty">
                    <img src="@/assets/images/passengers-qty-icon.svg" alt="" />
                    <div class="qty-text text-h6 text-bold">
                        {{ passengerCount }}
                    </div>
                </div>
                <div v-if="parcelCount > 0" class="parcels-qty">
                    <img src="@/assets/images/parcels-qty-icon.svg" alt="" />
                    <div class="qty-text text-h6 text-bold">
                        {{ parcelCount }}
                    </div>
                </div>

                <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="route-btn-icon"
                >
                    <circle cx="15" cy="15" r="10.5" fill="#EFEFEF" />
                    <path d="M10.5 13.5L15 18" stroke="black" stroke-linecap="round" />
                    <path d="M19.5 13.5L15 18" stroke="black" stroke-linecap="round" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import { useActiveRouteStore, useModalStore } from '@/stores/index.js'

export default {
    name: 'ActiveRoutePoint',
    components: {},
    props: {
        pointData: {
            type: Object,
            required: true
        },
        lastCompleted: {
            type: Boolean,
            required: true
        },
        firstUncompleted: {
            type: Boolean,
            required: true
        },
        pointIndex: {
            type: Number,
            required: true
        }
    },
    setup() {
        const activeRouteStore = useActiveRouteStore()
        const modalStore = useModalStore()

        return {
            activeRouteStore,
            modalStore
        }
    },
    computed: {
        parcelCount() {
            if (Number.isFinite(this.pointData?.parcels_count)) {
                return this.pointData.parcels_count
            }

            return this.pointData?.items?.filter((item) => item.type === 'parcel').length || 0
        },

        passengerCount() {
            if (Number.isFinite(this.pointData?.passengers_count)) {
                return this.pointData.passengers_count
            }

            return this.pointData?.items?.filter((item) => item.type === 'passenger').length || 0
        }
    },
    methods: {
        openPointModal() {
            this.modalStore.activeRoutePointModal.pointId = this.pointData.id
            this.modalStore.activeRoutePointModal.firstUncompleted = this.firstUncompleted
            this.modalStore.activeRoutePointModal.lastCompleted = this.lastCompleted
            this.modalStore.activeRoutePointModal.show = true
            this.activeRouteStore.loadPointData(this.pointData.id)
        },
        openCommentModal() {
            this.modalStore.commentModal.text = this.pointData?.comment?.text || ''
            this.modalStore.commentModal.show = true
        }
    }
}
</script>

<style scoped lang="scss">
.active-route-point {
    padding: 0.5rem 0;
}

.route-point-header {
    display: flex;
    align-items: center;
    cursor: pointer;

    .route-status {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.5rem;
        width: 1.25rem;
        min-width: 1.25rem;
        height: 1.25rem;
        border-radius: 50%;
        color: $white;
    }

    .route-address {
        margin-right: auto;
    }

    .route-icons {
        display: flex;
        align-items: center;
        margin-left: 1rem;
        flex-shrink: 0;

        .quick-note-btn,
        .passengers-qty,
        .parcels-qty {
            display: flex;
            align-items: center;
            margin-right: 0.5rem;

            img {
                width: 1.5rem;
                height: 1.5rem;
            }
        }

        .route-btn-icon {
            width: 1.875rem;
            min-width: 1.875rem;
            transform: rotate(-90deg);
        }
    }
}
</style>
